import {
    cleanCommonParams,
    mapTagsParams,
} from './common';

const mapImageParams = (
    isCreate,
    {
        resources,
        tags,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            image: {
                ...cleanCommonParams(params),
                ...mapTagsParams(isCreate, tags),
            },
        });
    });
};

export { mapImageParams };
